export function addReadMoreButton() {
    if ($('#read_more_button').length === 0) {
        var readMorebutton = "<div class='row' id='read_more_button_container'><div class='col-xs-12 text-center'><button class='button_red' id='read_more_button'>Mehr anzeigen</button></div></div>";
        $(readMorebutton).insertAfter($(".timeline_entry").last());
    }
}